import { render, staticRenderFns } from "./topTitle.vue?vue&type=template&id=b528d08e&scoped=true&"
import script from "./topTitle.vue?vue&type=script&lang=js&"
export * from "./topTitle.vue?vue&type=script&lang=js&"
import style0 from "./topTitle.vue?vue&type=style&index=0&id=b528d08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b528d08e",
  null
  
)

export default component.exports